import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["httpClient", "onTrack", "onOpenSmartPropertyCitationPanel", "children"];
import { PropertyValueCitationPopover } from './PropertyValueCitationPopover';
import { CrmLinksDataProvider } from 'crm-links/common/context/CrmLinksDataProvider';
import { HttpClientContextProvider } from '../../client/HttpClientContext';
import { RpcClientContextProvider } from '../../client/RpcClientContext';
import { parseCitationSource } from '../../utils/parseCitationSource';
import { jsx as _jsx } from "react/jsx-runtime";
export function PropertyValueCitation(_ref) {
  let {
      httpClient,
      onTrack,
      onOpenSmartPropertyCitationPanel,
      children
    } = _ref,
    citationSource = _objectWithoutPropertiesLoose(_ref, _excluded);
  const parsedCitationSource = parseCitationSource(citationSource);
  if (!parsedCitationSource) {
    return null;
  }
  const {
    citationType,
    citationId
  } = parsedCitationSource;
  return /*#__PURE__*/_jsx(CrmLinksDataProvider, {
    children: /*#__PURE__*/_jsx(HttpClientContextProvider, {
      httpClient: httpClient,
      children: /*#__PURE__*/_jsx(RpcClientContextProvider, {
        httpClient: httpClient,
        children: /*#__PURE__*/_jsx(PropertyValueCitationPopover, {
          citationType: citationType,
          citationId: citationId,
          onOpenSmartPropertyCitationPanel: onOpenSmartPropertyCitationPanel,
          onTrack: onTrack,
          children: children
        })
      })
    })
  });
}